/**
 * Abstract class used to define the class structure of a json api model
 */
export abstract class JsonApiModel {
    public id: string = null;

    constructor(id?: string) {
        this.id = id;
    }

    public abstract clone(): any;

    public abstract deserialize(json: any, included: any[]): any;
}
